import { FilterBoard, NestFilterLayout } from "./FilterLayout";
import FilterListItem from "./FilterListItem";

export const PageFilterPanel = {
  Board: FilterBoard,
  ListItem: FilterListItem,
  NestItem: NestFilterLayout,
};
